import moment from 'moment';
import { isInGodMode } from '../_utils';
import { getCurrentlyPurchasingUser } from './userSelector';
import paymentConfig from '../store/_payment';

const generateFakeID = function () {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return (
        '_' +
        Math.random()
            .toString(36)
            .substr(2, 9)
    );
};

export const getPurchasingMemberType = (store) => {
    const user = getCurrentlyPurchasingUser(store);
    let userType = user.type.toLowerCase();

    if (typeof userType != 'undefined' && userType && userType == 'customer') {
        userType = 'retail-customer';
    }

    return userType || 'retail-customer';
};
export const getMemberType = (store) => {
    let userType = store.user.type.toLowerCase();

    if (typeof userType != 'undefined' && userType && userType == 'customer') {
        userType = 'retail-customer';
    }

    return userType || 'retail-customer';
};
export const getMemberID = (store) => {
    let userID = store.user.info?.basicInfo?.ID
    return userID;
};
export const getMemberProductConfiguratorType = (store) => {
    let userType = store.user.productConfiguratorType.toLowerCase();

    return userType || '';
};
export const getShowProductPrice = (store) => {
    if (store.user.subStore) {
        return store.user.subStoreDisplayPrice;
    }

    return true;
};
export const getSelectedItems = (list, selected) => {
    let newList = [];

    Object.entries(selected).map(([id, value]) => {
        if (value === true) {
            if (typeof list[id] != 'undefined' && list[id]) {
                newList.push(list[id]);
            }
        }
    });

    return newList;
};
export const buildFilterParams = (filters) => {
    let filterParams = [];

    const filtersArray = Object.entries(filters);

    if (filtersArray.length) {
        filtersArray.map(([key, value]) => {
            if (key.substr(0, 7) != 'ignore:') {
                if (typeof value === 'string' && value != '') {
                    filterParams.push(`${key}: "${value}"`);
                } else if (
                    typeof value === 'number' ||
                    typeof value === 'boolean'
                ) {
                    filterParams.push(`${key}: ${value}`);
                } else if (Array.isArray(value)) {
                    let valueHolder = [];
                    value.map((theValue) => {
                        if (typeof theValue === 'string' && theValue != '') {
                            valueHolder.push(
                                `"${escapeGraphQLInput(theValue)}"`
                            );
                        } else if (
                            typeof theValue === 'number' ||
                            typeof theValue === 'boolean'
                        ) {
                            valueHolder.push(theValue);
                        }
                    });

                    filterParams.push(`${key}: [${valueHolder.join(',')}]`);
                } else if (value !== undefined && value !== null) {
                    Object.entries(value).map(([vKey, vValue]) => {
                        if (typeof vValue === 'string' && vValue != '') {
                            filterParams.push(
                                `${vKey}: "${escapeGraphQLInput(vValue)}"`
                            );
                        } else {
                            filterParams.push(`${vKey}: ${vValue}`);
                        }
                    });
                }
            }
        });
    }

    return filterParams;
};
/**
 * Helper to build query for pure GraphQL
 * @param state
 * @param config
 * @returns {string}
 */
export const buildGraphQLParams = (state, config) => {
    const { perPage, activePage, filters, sortBy, sortDirection } = state;

    // config
    const useGroupedFilter =
        typeof config != 'undefined' &&
            typeof config.useGroupedFilter != 'undefined'
            ? config.useGroupedFilter
            : false;
    const groupedFilterName =
        typeof config != 'undefined' &&
            typeof config.groupedFilterName != 'undefined'
            ? config.groupedFilterName
            : 'Filters';

    let params = [];

    // limit
    if (typeof perPage != 'undefined') {
        params.push(`limit: ${perPage}`);
    }

    // offset
    if (typeof perPage != 'undefined' && typeof activePage != 'undefined') {
        const offset = (activePage - 1) * perPage;
        params.push(`offset: ${offset}`);
    }

    // filter
    if (typeof filters != 'undefined') {
        let filterParams = buildFilterParams(filters);
        if (filterParams.length) {
            if (useGroupedFilter) {
                params.push(`${groupedFilterName}: {${filterParams}}`);
            } else {
                params = [...params, ...filterParams];
            }
        }
    }

    // sort
    if (typeof sortBy != 'undefined' && typeof sortDirection != 'undefined') {
        if (sortBy && sortDirection) {
            params.push(`sort: "${sortBy}__${sortDirection}"`);
        }
    }

    return params.join(', ');
};

// Will be removed for all graphQL API changed with Filter Sort
export const buildGraphQLParamsV2 = (state, config) => {
    const { perPage, activePage, filters, sortBy, sortDirection } = state;

    // config
    const useGroupedFilter =
        typeof config != 'undefined' &&
            typeof config.useGroupedFilter != 'undefined'
            ? config.useGroupedFilter
            : false;
    const groupedFilterName =
        typeof config != 'undefined' &&
            typeof config.groupedFilterName != 'undefined'
            ? config.groupedFilterName
            : 'Filters';

    let params = [];

    // limit
    if (typeof perPage != 'undefined') {
        params.push(`limit: ${perPage}`);
    }

    // offset
    if (typeof perPage != 'undefined' && typeof activePage != 'undefined') {
        const offset = (activePage - 1) * perPage;
        params.push(`offset: ${offset}`);
    }

    // filter
    if (typeof filters != 'undefined') {
        let filterParams = buildFilterParams(filters);
        if (filterParams.length) {
            if (useGroupedFilter) {
                params.push(`${groupedFilterName}: {${filterParams}}`);
            } else {
                params = [...params, ...filterParams];
            }
        }
    }

    // sort
    if (typeof sortBy != 'undefined' && typeof sortDirection != 'undefined') {
        if (sortBy && sortDirection) {
            params.push(`Filters: { Sort: "${sortBy}__${sortDirection}"}`);
        }
    }

    return params.join(', ');
};
/**
 * Helper to build query for GraphQL that loads data from elastic
 * @param state
 * @returns {string}
 */
export const buildElasticGraphQLParams = (state) => {
    const { perPage, activePage, filters, sortBy, sortDirection } = state;
    let filterQueryBuilder = [];

    let params = [];

    // limit
    if (typeof perPage != 'undefined') {
        params.push(`limit: ${perPage}`);
    }

    // offset
    if (typeof perPage != 'undefined' && typeof activePage != 'undefined') {
        const offset = (activePage - 1) * perPage;
        params.push(`offset: ${offset}`);
    }

    // filter
    if (typeof filters != 'undefined') {
        let filterParams = buildFilterParams(filters);
        if (filterParams.length) {
            filterQueryBuilder = [...filterQueryBuilder, ...filterParams];
        }
    }

    // sort
    if (typeof sortBy != 'undefined' && typeof sortDirection != 'undefined') {
        if (sortBy && sortDirection) {
            filterQueryBuilder = [
                ...filterQueryBuilder,
                `Sort: "${sortBy}__${sortDirection}"`,
            ];
        }
    }

    if (filterQueryBuilder.length) {
        params.push(`Filters: {${filterQueryBuilder.join(', ')}}`);
    }

    return params.join(', ');
};
export const getGraphQLTotalRecords = (data) => {
    if (typeof data.pageInfo == 'undefined') {
        if (Array.isArray(data)) {
            return data.length;
        }

        return 0;
    }

    return data.pageInfo.totalCount;
};
export const convertDataToListingDisplay = (data, key) => {
    let list = [];

    if (typeof data.edges == 'undefined') {
        if (Array.isArray(data)) {
            data.map((item) => {
                list.push(item[key]);
            });

            return list;
        }

        return [];
    }

    data.edges.map((item) => {
        const { node } = item;

        if (typeof node[key] != 'undefined') {
            list.push(node[key]);
        }
    });

    return list;
};
export const convertProductsListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item, idx) => {
        const product = convertProductGraphQLNodeToAReadableFormat(item);
        list[product.ID] = {
            ...product,
            order: idx,
        };
    });

    return list;
};
export const convertProductGraphQLNodeToAReadableFormat = (item) => {
    const { node } = item;
    const { memberType, orderOnBehalf, locale } = window;

    let MinOrderQuantity = 1;
    if (memberType.toLowerCase() === 'wholesaler' && orderOnBehalf === false) {
        MinOrderQuantity = node.WholesaleMinOrderQuantity || MinOrderQuantity;
    } else {
        MinOrderQuantity = node.MinOrderQuantity || MinOrderQuantity;
    }

    let data = {
        ID: node.ID,
        Title: node.Title,
        FamilyTitle: typeof node.FamilyTitle != 'undefined' ? node.FamilyTitle : '',
        FamilyTitleSlug: typeof node.FamilyTitleSlug != 'undefined' ? node.FamilyTitleSlug : '',
        ProdType: node.ProdType,
        URLSegment: node.URLSegment,
        Content: node.Content,
        InternalItemID: node.InternalItemID,
        ReSizedProductDetailImage: node.ReSizedProductDetailImage,
        ReSizedProductListingImage: node.ReSizedProductListingImage,
        IsContinuesSequenceCheckDisabled: node.IsContinuesSequenceCheckDisabled,
        Link:
            typeof node.DirectProductCategoriesList != 'undefined'
                ? `/${locale}${node.DirectProductCategoriesList.edges[0].node.ProductLink}` ||
                ''
                : '',
        IsBuyable: true, // only false for InStoreProduct
        MinOrderQuantity: MinOrderQuantity,
        TagColour: typeof node.TagColour != 'undefined' ? node.TagColour : '',
        FontColourCode:
            typeof node.FontColourCode != 'undefined'
                ? node.FontColourCode
                : '',
        ColourCode:
            typeof node.ColourCode != 'undefined' ? node.ColourCode : '',
        OfficialColourName:
            typeof node.OfficialColourName != 'undefined'
                ? node.OfficialColourName
                : '',
        FoilStamping:
            typeof node.FoilStamping != 'undefined' ? node.FoilStamping : '',
        IsNLIS: typeof node.IsNLIS != 'undefined' ? node.IsNLIS : false,
        BlankTag: typeof node.BlankTag != 'undefined' ? node.BlankTag : false,
        Brand: typeof node.Brand != 'undefined' ? node.Brand : false,
        DiseaseCode:
            typeof node.DiseaseCode != 'undefined' ? node.DiseaseCode : false,
        PostBreederLetter:
            typeof node.PostBreederLetter != 'undefined'
                ? node.PostBreederLetter
                : '',
        TagShape: typeof node.TagShape != 'undefined' ? node.TagShape : '',
        CustomTag:
            typeof node.CustomTag != 'undefined' ? (node.CustomTag != 0) : false, // temporary fix
        ExtraInfo: [],
        Images: [],
        ItemWidth: typeof node.ItemWidth != 'undefined' ? node.ItemWidth : '',
        ItemHeight:
            typeof node.ItemHeight != 'undefined' ? node.ItemHeight : '',
        ItemDepth: typeof node.ItemDepth != 'undefined' ? node.ItemDepth : '',
        ItemWeight:
            typeof node.ItemWeight != 'undefined' ? node.ItemWeight : '',
        RelatedTags: [],
        RelatedProducts: [],
        ButtonRequired:
            typeof node.ButtonRequired != 'undefined' ? node.ButtonRequired : 0,
        CodeTagFamily:
            typeof node.CodeTagFamily != 'undefined' ? node.CodeTagFamily : '',
        SellByPackageOnly: typeof node.SellByPackageOnly != 'undefined' ? node.SellByPackageOnly : false,
        MatchingManagementTags: [],
        MaleButtons: [],
        MarkingLines: node.MarkingLines || '',
        FoilMarkingLines: node.FoilMarkingLines || '',
        AllowVic: typeof node.AllowVic != 'undefined' ? node.AllowVic : false,
        BuyableContinueSequence: typeof node.BuyableContinueSequence != 'undefined' ? node.BuyableContinueSequence : false,
        OfficialType: typeof node.OfficialType != 'undefined' ? node.OfficialType : null,
        Replacement: typeof node.Replacement != 'undefined' ? node.Replacement : false,
        IsCattle: typeof node.IsCattle != 'undefined' ? node.IsCattle : false,
        IsDeer: typeof node.IsDeer != 'undefined' ? node.IsDeer : false,
    };

    for (let i = 1; i <= 4; i++) {
        let variableName = 'ExtraText' + i;
        if (typeof node[variableName] != 'undefined' && node[variableName]) {
            const [Title, Content] = node[variableName].split(':');

            data.ExtraInfo.push({
                Title: Title + ': ',
                Content: Content,
            });
        }
    }

    for (let i = 1; i <= 4; i++) {
        let variableName = 'MMT' + i;
        if (typeof node[variableName] != 'undefined' && node[variableName]) {
            data.MatchingManagementTags.push({
                CodeTagFamily: node[variableName],
                Sex: 'male',
            });
        }

        variableName = 'MMTF' + i;
        if (typeof node[variableName] != 'undefined' && node[variableName]) {
            data.MatchingManagementTags.push({
                CodeTagFamily: node[variableName],
                Sex: 'female',
            });
        }
    }

    if (typeof node.Images != 'undefined') {
        data.Images = node.Images.edges.map((image) => {
            return image.node;
        });
    }

    if (typeof node.RelatedTags != 'undefined') {
        data.RelatedTags = node.RelatedTags.edges.map((relatedTag) => {
            return relatedTag.node.ID;
        });
    }

    if (typeof node.MaleButtons != 'undefined') {
        data.MaleButtons = node.MaleButtons.edges.map((maleButtonProduct) => {
            return maleButtonProduct.node.ID;
        });
    }

    if (typeof node.RelatedProducts != 'undefined') {
        data.RelatedProducts = node.RelatedProducts.edges.map(
            (relatedProduct, key) => {
                return {
                    ID: relatedProduct.node.ID,
                    Order: key,
                };
            }
        );
    }

    // GOD MODE OVERWRITE
    if (isInGodMode()) {
        // Keep the backup copy
        data._CustomTag = data.CustomTag;
        data.CustomTag = true;
    }

    return data;
};
export const getProductsListingRelatedProductIDs = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;

        if (typeof node.RelatedProducts != 'undefined') {
            node.RelatedProducts.edges.map((relatedProduct, key) => {
                const product = convertProductGraphQLNodeToAReadableFormat(
                    relatedProduct
                );

                list[product.ID] = product.ID;
            });
        }
    });

    return Object.keys(list);
};

export const getProductsListingRelatedProductIDsByCurrentID = (
    data,
    currentProductID
) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = [];

    data.edges.forEach((item) => {
        const { node } = item;

        if (currentProductID && node.ID !== currentProductID.toString()) {
            return false;
        }

        if (typeof node.RelatedProducts != 'undefined') {
            list = node.RelatedProducts.edges.map((relatedProduct) => {
                const product = convertProductGraphQLNodeToAReadableFormat(
                    relatedProduct
                );

                return product.ID;
            });
        }
    });

    return list;
};

export const getProductsListingMatchingManagementTagIDs = (data) => {
    let list = Object.values(data).reduce((products, product) => {
        const { MatchingManagementTags } = product;

        if (MatchingManagementTags.length > 0) {
            MatchingManagementTags.forEach(id => {
                products[id?.CodeTagFamily] = id?.CodeTagFamily;
            });
        }

        return products;
    }, {});

    return Object.keys(list);
};
export const getProductsListingMaleButtonIDs = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = data.edges.reduce((products, product) => {
        const { MaleButtons } = product.node;

        if (MaleButtons.edges.length > 0) {
            MaleButtons.edges.forEach(MaleButton => {
                const { ID } = MaleButton.node;
                products[ID] = ID;
            });
        }

        return products;
    }, {});

    return Object.keys(list);
};
export const getProductsListingRelatedTagIDs = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item, key) => {
        const { node } = item;

        if (typeof node.RelatedTags != 'undefined') {
            node.RelatedTags.edges.map((relatedTag) => {
                const product = convertProductGraphQLNodeToAReadableFormat(
                    relatedTag
                );

                list[product.ID] = product.ID;
            });
        }
    });

    return Object.keys(list);
};
export const convertProductCategoriesToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};
    data.edges.map((item) => {
        const { node } = item;
        const identifier = node.ID;

        list[identifier] = {
            ...node,
            ParentID: typeof node.Parent.ID != 'undefined' ? node.Parent.ID : 0,
        };

        delete list[identifier].Parent;
    });

    list = Object.values(list);

    const buildTree = (parentID) => {
        var result = {};
        for (var i = 0; i < list.length; i++) {
            if (list[i].ParentID === parentID) {
                var ch = buildTree(list[i].ID);
                var o = Object.keys(ch).length === 0 ? {} : { Children: ch };
                result[list[i].ID] = Object.assign(o, list[i]);
            }
        }

        return result;
    };

    return buildTree(0);
};
export const convertProductSalePricesToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        const identifier = node.BuyableID;

        list[identifier] = {
            ...node,
            IsSale: node.RRP != null && node.SalePrice < node.RRP,
        };
    });

    return list;
};

export const convertProductListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;

        const identifier = node.ID;
        list[identifier] = {
            BuyableID: node.ID,
            Title: node.Title,
            FamilyTitle: node.FamilyTitle,
            FamilyTitleSlug: node.FamilyTitleSlug,
            ProdType: node.ProdType,
            IsNLIS: node.IsNLIS,
            InternalItemID: node.InternalItemID,
            ReSizedProductListingImage: node.ReSizedProductListingImage,
            COGS: node.COGS,
            //DirectProductCategoriesList
        };
    });

    return list;
};

export const convertProductConfiguratorListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        const identifier = node.BuyableID;

        list[identifier] = {
            StockOnHandUnits: node.StockOnHandUnits,
            StockOnHandPackages: node.StockOnHandPackages,
            WarehouseCode: node.WarehouseCode,
            ProductsWarehouseID: node.ProductsWarehouseID,
        };
    });

    return list;
};
export const convertProductConfiguratorBuyPricesToAReadableFormat = (data) => {
    if (typeof data == 'undefined') {
        return {};
    }

    let list = {};

    data.map((node) => {
        const identifier = node.BuyableID;

        list[identifier] = {
            ...node
        };
    });

    return list;
};
export const convertProductConfiguratorSellPricesToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        const identifier = node.BuyableID;

        list[identifier] = {
            SellPrice: node.SalePrice,
            SellPriceCurrency: node.Currency,
        };
    });

    return list;
};
export const convertCouponListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;

        if (node.HasExpired) {
            node.HasExpired = node.HasExpired == 'true' ? true : false;
        }

        list[node.ID] = node;
    });

    return list;
};

export const convertReferralDetailToAReadableFormat = (data) => {
    if (typeof data == 'undefined') {
        return {};
    }

    return data;
};

export const convertOneInStoreProductToAReadableFormat = (data) => {
    let finalData = {};

    if (data.edges.length) {
        finalData = {
            ...data.edges[0].node,
            Images: [],
            DisplayedImages: [],
        };

        data.edges[0].node.Images.edges.forEach((item) => {
            const { node } = item;
            const { ID, ReSizedProductDetailImage } = node;

            finalData.Images.push(ID);
            finalData.DisplayedImages.push({
                id: ID,
                preview: ReSizedProductDetailImage,
            });
        });
    }

    return finalData;
};
export const convertInStoreProductsListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = node;
        list[node.ID].Price = Number(list[node.ID].Price);
        list[node.ID].Image =
            typeof node.Images.edges != 'undefined' &&
                node.Images.edges.length > 0
                ? node.Images.edges[0].node.ReSizedProductListingImage
                : '';
    });

    return list;
};
export const convertInStoreCategoriesToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = node;
    });

    return list;
};
export const convertPICNumberListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = node;
    });

    return list;
};
export const convertCreditCardListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = {
            ...node,
            ExpiryMonthYear: node.Month + '/' + node.Year,
        };
    });

    return list;
};
export const convertBankDetailToAReadableFormat = (data) => {
    let list = {};

    if (typeof data.edges == 'undefined') {
        if (Array.isArray(data)) {
            data.map((item) => {
                list = item;
            });

            return list;
        }

        return {};
    }
};
export const convertInvoiceListingToAReadableFormat = (data) => {
    let list = {};

    if (typeof data.edges == 'undefined') {
        if (Array.isArray(data)) {
            data.map((item) => {
                list[item.ID] = item;
            });

            return list;
        }

        return {};
    }

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = node;
    });

    return list;
};
export const convertOrderListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = {
            ...node,
            StatusNice: node.Status,
            Supplier: null,
        };

        if (typeof node.Placed != 'undefined') {
            list[node.ID].PlacedNice = node.Placed
                ? moment(node.Placed).format('DD/MM/YYYY')
                : '';
        }
        if (typeof node.Paid != 'undefined') {
            list[node.ID].PaidNice = node.Paid
                ? moment(node.Paid).format('DD/MM/YYYY')
                : '';
        }
        if (typeof node.Created != 'undefined') {
            list[node.ID].CreatedNice = node.Created
                ? moment(node.Created).format('DD/MM/YYYY')
                : '';
        }

        if (typeof node.PaymentMethod != 'undefined') {
            list[
                node.ID
            ].PaymentMethodNice = convertPaymentMethodToAReadableFormat(
                node.PaymentMethod
            );
        }

        if (
            typeof node.PlacedOnBehalfBy != 'undefined' &&
            node.PlacedOnBehalfBy &&
            node.PlacedOnBehalfBy.ID > 0
        ) {
            list[node.ID].Supplier = {
                ...node.PlacedOnBehalfBy,
                FullName: combineNames([
                    node.PlacedOnBehalfBy.FirstName,
                    node.PlacedOnBehalfBy.Surname,
                ]),
            };
        } else if (
            typeof node.ParentMember != 'undefined' &&
            node.ParentMember &&
            node.ParentMember.ID > 0
        ) {
            list[node.ID].Supplier = {
                ...node.ParentMember,
                FullName: combineNames([
                    node.ParentMember.FirstName,
                    node.ParentMember.Surname,
                ]),
            };
        }

        list[node.ID].BillingAddress =
            node.BillingAddress &&
                typeof node.BillingAddress.FullAddress != 'undefined'
                ? node.BillingAddress.FullAddress
                : '';
        list[node.ID].ShippingAddress =
            node.ShippingAddress &&
                typeof node.ShippingAddress.FullAddress != 'undefined'
                ? node.ShippingAddress.FullAddress
                : '';

        if (list[node.ID].StatusNice === 'Buyer Contacted') {
            list[node.ID].StatusNice = 'Contact Customer';
        }
    });

    return list;
};
export const convertDispatchListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        const { ShippingStatus } = node;

        let finalData = {
            ...node,
            DeliverTo: node.BusinessName ? node.BusinessName : `${node.FirstName} ${node.Surname}`,
        };

        if (ShippingStatus === '') {
            finalData.DispatchStatus = 'UNPACKED';
        }
        else if (ShippingStatus === 'Awaiting Pickup') {
            finalData.DispatchStatus = 'READY FOR COLLECTION';
        }
        else if (ShippingStatus === 'Packed') {
            finalData.DispatchStatus = 'PACKED';
        }

        if (typeof node.Placed != 'undefined' && node.Placed) {
            finalData.PlacedNice = moment(node.Placed).format('DD/MM/YYYY');
        }

        list[node.ID] = finalData;
    });

    return list;
};
export const convertManifestListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;

        let finalData = {
            ...node,
        };

        if (typeof node.Created != 'undefined' && node.Created) {
            finalData.CreatedNice = moment(node.Created).format('DD/MM/YYYY');
        }

        list[node.ID] = finalData;
    });

    return list;
};
export const convertDispatchHistoryListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;

        let finalData = {
            ...node,
            DeliverTo: node.BusinessName ? node.BusinessName : `${node.FirstName} ${node.Surname}`,
        };

        if (typeof node.Placed != 'undefined' && node.Placed) {
            finalData.PlacedNice = moment(node.Placed).format('DD/MM/YYYY');
        }

        list[node.ID] = finalData;
    });

    return list;
};
export const convertPaymentMethodToAReadableFormat = (method) => {
    switch (method.toLowerCase()) {
        case 'order-account':
            return 'Charge Account';
        case 'order-card':
        case 'order-card-authorization':
        case 'order-card-reference':
        case 'order-capture-card':
        case 'order-token':
            return 'Credit Card';
        case 'order-bank-transfer':
            return 'Bank Transfer';
        case 'order-card-authorization-payfast':
            return 'PayFast';
        case 'order-refund-card':
            return 'Credit Card';
    }

    return '';
};
export const convertOrderDetailToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let finalData = {};

    data.edges.map((item) => {
        const { node } = item;
        finalData = {
            ...node,
            Supplier: null,
            Items: [],
        };

        node.Items.edges.map((orderItem) => {
            finalData.Items.push(orderItem.node);
        });

        if (typeof node.Placed != 'undefined' && node.Placed) {
            finalData.PlacedNice = moment(node.Placed).format('DD/MM/YYYY');
        }
        if (typeof node.Paid != 'undefined' && node.Paid) {
            finalData.PaidNice = moment(node.Paid).format('DD/MM/YYYY');
        }
        if (typeof node.Created != 'undefined' && node.Created) {
            finalData.CreatedNice = moment(node.Created).format('DD/MM/YYYY');
        }

        if (typeof node.PaymentMethod != 'undefined') {
            finalData.PaymentMethodNice = convertPaymentMethodToAReadableFormat(
                node.PaymentMethod
            );
        }

        if (
            typeof node.PlacedOnBehalfBy != 'undefined' &&
            node.PlacedOnBehalfBy &&
            node.PlacedOnBehalfBy.ID > 0
        ) {
            finalData.Supplier = {
                ...node.PlacedOnBehalfBy,
                FullName: combineNames([
                    node.PlacedOnBehalfBy.FirstName,
                    node.PlacedOnBehalfBy.Surname,
                ]),
            };
        } else if (
            typeof node.ParentMember != 'undefined' &&
            node.ParentMember &&
            node.ParentMember.ID > 0
        ) {
            finalData.Supplier = {
                ...node.ParentMember,
                FullName: combineNames([
                    node.ParentMember.FirstName,
                    node.ParentMember.Surname,
                ]),
            };
        }

        finalData.BillingAddress =
            node.BillingAddress &&
                typeof node.BillingAddress.FullAddress != 'undefined'
                ? node.BillingAddress.FullAddress
                : '';
        finalData.ShippingAddress =
            node.ShippingAddress &&
                typeof node.ShippingAddress.FullAddress != 'undefined'
                ? node.ShippingAddress.FullAddress
                : '';
    });

    return finalData;
};
export const convertDeliveryOptionsToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        let fakeID = generateFakeID();

        // We don't receive ID from backend, so let's just create one :<
        list[fakeID] = {
            FakeID: fakeID,
            ...node,
        };
    });

    return list;
};
export const convertCartBasicInfoToAReadableFormat = (data) => {
    if (typeof data == 'undefined') {
        return {};
    }

    let finalData = {
        DiscountTotal: data.DiscountTotal,
        ShippingTotal: data.ShippingTotal,
        SubTotal: data.SubTotal,
        TaxTotal: data.TaxTotal,
        Total: data.Total,
        DiscountTitle:
            (data.AppliedDiscountCoupon && data.AppliedDiscountCoupon.Title) ||
            '',
        InternalItemID:
            (data.AppliedDiscountCoupon &&
                data.AppliedDiscountCoupon.InternalItemID) ||
            '',
        HasTaxInclusive: data.HasTaxInclusive,
    };

    // make it from json to array
    if (data.TaxSummary) {
        const parsedTaxSummary = JSON.parse(data.TaxSummary);
        finalData = {
            ...finalData,
            TaxSummary: Object.keys(parsedTaxSummary).map(index => {
                return {
                    Title: parsedTaxSummary[index].Title,
                    CalculatedTax: parsedTaxSummary[index].Value,
                    IsCompound: parsedTaxSummary[index].IsCompound,
                    IsInclusive: parsedTaxSummary[index].IsInclusive,
                    Display: parsedTaxSummary[index].Display,
                };
            }),
        }
    }

    // deprecated
    // if (data.TaxDataItems && typeof data.TaxDataItems.edges != 'undefined') {
    //     finalData = {
    //         ...finalData,
    //         TaxDataItems: data.TaxDataItems.edges.map((edge) => {
    //             return {
    //                 Title: edge.node.Title,
    //                 CalculatedTax: edge.node.CalculatedTax,
    //             };
    //         }),
    //     };
    // }

    return finalData;
};
export const convertCartDetailsToAReadableFormat = (data) => {
    if (typeof data == 'undefined') {
        return {};
    }

    let finalData = {
        BusinessName: data.BusinessName,
        TradingName: data.TradingName,
        FirstName: data.FirstName,
        Surname: data.Surname,
        Email: data.Email,
        Phone: data.Phone,
        Notes: data.Notes,
        AppliedDiscountCode: data.AppliedDiscountCoupon.InternalItemID || '',
        AppliedDiscountCouponID: data.AppliedDiscountCoupon.ID ?? 0,
        ShippingID: data.Shipping.ID || 0,
        PurchaseOrderNumber: data.ExtraAttribute1 || '',
        PaymentMethod: convertCartPaymentMethodToCheckout(data.PaymentMethod) || '',
        IsTotalGreaterThanSourceOrder: data.IsTotalGreaterThanSourceOrder || false,
        IsPaymentCaptureFailed: data.IsPaymentCaptureFailed || false,
        HasSourceOrder: (data.SourceOrder.ID > 0) || false,
        SourceOrder: {
            ...data.SourceOrder,
            PaymentMethod: convertCartPaymentMethodToCheckout(data.SourceOrder.PaymentMethod) || '',
        },
        IsBackOrder: data.IsBackOrder,
        AppliedDiscountTotal: data.AppliedDiscountTotal ?? 0.00,
        // BillingAddressID: data.BillingAddress.ID || 0,
        // DeliveryAddressID: data.ShippingAddress.ID || 0,
        // DeliveryAddress: data.ShippingAddress.FullAddress || '',
    };

    if (data?.ProductDiscountItems) {
        finalData.ProductDiscountItems = convertCartProductCouponsToCheckout(data.ProductDiscountItems);
    }

    if (typeof finalData.IsTotalGreaterThanSourceOrder === 'string') {
        finalData.IsTotalGreaterThanSourceOrder = (finalData.IsTotalGreaterThanSourceOrder === 'true');
    }
    if (typeof finalData.IsPaymentCaptureFailed === 'string') {
        finalData.IsPaymentCaptureFailed = (finalData.IsPaymentCaptureFailed === 'true');
    }

    return finalData;
};

export const convertCartProductCouponsToCheckout = (data) => {
    if (data == 'undefined') {
        return [];
    }
    let list = [];
    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = node;
    });

    return list;
};
export const convertCartPaymentMethodToCheckout = (data) => {
    switch (data) {
        case 'order-account':
            return paymentConfig.gatewayNames.accountBalance;
        case 'order-card':
        case 'order-card-authorization':
        case 'order-card-reference':
        case 'order-capture-card':
        case 'order-token':
            return paymentConfig.gatewayNames.stripe;
        case 'order-bank-transfer':
            return paymentConfig.gatewayNames.bankTransfer;
        default:
            return '';
    }
};
export const convertCartItemsToAReadableFormat = (data) => {
    const { memberType, orderOnBehalf, locale } = window;

    if (typeof data.Items == 'undefined') {
        return {};
    }

    let list = {};

    data.Items.edges.map((item) => {
        const { node } = item;
        list[node.ID] = {
            ...node,
            Link: '',
            MinOrderQuantity: 1,
            SellByPackageOnly: false,
            ParentItemID: 0,
            _TotalUnitItems: node.TotalUnitItems, // this is to the original value
            CanEditQuantity: true,
            CanDelete: true,
        };

        if (typeof node.Buyable != 'undefined') {
            let MinOrderQuantity = 1;
            if (memberType.toLowerCase() === 'wholesaler' && orderOnBehalf === false) {
                MinOrderQuantity = node.Buyable.WholesaleMinOrderQuantity || MinOrderQuantity;
            } else {
                MinOrderQuantity = node.Buyable.MinOrderQuantity || MinOrderQuantity;
            }

            list[node.ID] = {
                ...list[node.ID],
                MinOrderQuantity: MinOrderQuantity,
                SellByPackageOnly: node.Buyable.SellByPackageOnly || false,
            };
        }

        if (
            typeof node.ParentItem != 'undefined' &&
            typeof node.ParentItem.ID != 'undefined'
        ) {
            const isCustomTag = typeof (list[node.ID].IsCustomTag) != 'undefined' ? list[node.ID].IsCustomTag : false;

            list[node.ID] = {
                ...list[node.ID],
                ParentItemID: node.ParentItem.ID,
                CanEditQuantity: !isCustomTag,
                CanDelete: !isCustomTag,
            };
        }

        delete list[node.ID].Buyable;
        delete list[node.ID].ParentItem;
    });

    Object.entries(list).forEach(([id, cartItem]) => {
        const { ParentItemID } = cartItem;
        if (ParentItemID > 0) {
            const isParentCustom = list[ParentItemID] && typeof (list[ParentItemID].IsCustomTag) != 'undefined' ? list[ParentItemID].IsCustomTag : false;
            if (isParentCustom) {
                list[id].CanEditQuantity = false;
                list[id].CanDelete = false;
            }
        }
    });

    return list;
};
export const convertCustomerListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        if (typeof node.Created != 'undefined' && node.Created) {
            node.CreatedNice = moment(node.Created).format('DD/MM/YYYY');
        }
        list[node.ID] = node;
    });

    return list;
};
export const convertInStoreProductsIntoProductListing = (list) => {
    let newList = {};

    Object.entries(list).map(([key, node]) => {
        newList[key] = {
            ID: node.ID,
            Title: node.Title,
            ProdType: 'InStore',
            URLSegment: '',
            InternalItemID: node.InternalItemID,
            ReSizedProductListingImage: node.Image,
            Link: node.Link,
            SalePrice: node.Price,
            IsSale: false,
            IsBuyable: false,
            MinOrderQuantity: 1,
            TagColour: '',
            ExtraInfo: [],
        };
    });

    return newList;
};

export const convertUserDetailedInformationToAReadableFormat = (data) => {
    let finalData = {};

    if (!data) {
        return finalData;
    }

    const storeDataIfAvailable = (storage, source, key) => {
        if (
            typeof source != 'undefined' &&
            source &&
            typeof source[key] != 'undefined'
        ) {
            storage[key] = source[key];
        }
    };

    // Store all details key
    const detailsKey = [
        'ID',
        'EXOAccountID',
        'AccessCodeToCopyURL',
        'FirstName',
        'Surname',
        'Phone',
        'Mobile',
        'IsGuestUser',
        'Fax',
        'Email',
        'Website',
        'InternalItemID',
        'BusinessName',
        'ReferenceName',
        'ReferenceEmail',
        'ReferencePhone',
        'Reference2Name',
        'Reference2Email',
        'Reference2Phone',
        'BSB',
        'BankName',
        'BankAccountName',
        'BankAccountNumber',
        'BankSwiftCode',
        'ABN',
        'ACN',
        'CreateSubStoreAccessCode',
        'StripeCountryCode',
        'StripePublishableKey',
        'StripeSecretKey',
        'PayFastMerchantID',
        'PayFastMerchantKey',
        'PayFastPassphrase',
        'StripeDOB',
        'StripeIdentityCardNumber',
        'StripeBSB',
        'StripeBankAccountNumber',
        'StripeCompany_BusinessName',
        'StripeCompany_TaxId',
        'StripeFirstName',
        'StripeSurname',
        'StripeAddressStreetNumber',
        'StripeAddressSuburb',
        'StripeAddressState',
        'StripeAddressPostalCode',
        'IsStripeConnectComplete',
        'IsStripeConnectRequired',
        'IsStripeConnectExternalAccountDue',
        'IsStripeConnectOtherRequirementDue',
        'ProvidesCardPaymentMethod',
        'ProvidesAccountPaymentMethod',
    ];
    detailsKey.forEach((key) => {
        if (typeof finalData.basicInfo == 'undefined') {
            finalData.basicInfo = {};
        }
        storeDataIfAvailable(finalData.basicInfo, data, key);
    });

    if (Object.values(finalData.basicInfo).length == 0) {
        delete finalData.basicInfo;
    }

    // Wholesaler / Reseller
    if (
        typeof data.PreferredSuppliers != 'undefined' &&
        data.PreferredSuppliers
    ) {
        finalData.availableWholesalerReseller = data.PreferredSuppliers.edges.map(
            (item) => {
                const { node } = item;
                // const { Supplier } = node;
                return {
                    AccountReference: node.AccountReference,
                    SupplierID: Number(node.SupplierID),
                    SupplierName: node.SupplierName,
                    // SupplierFirstName: Supplier.FirstName,
                    // SupplierSurname: Supplier.Surname,
                    // SupplierName: `${Supplier.FirstName} ${Supplier.Surname}`.trim(),
                };
            }
        );
    }

    // PIC Numbers
    if (typeof data.PICNumbers != 'undefined' && data.PICNumbers) {
        finalData.availablePICNumbers = data.PICNumbers.edges.map((item) => {
            const { node } = item;
            return {
                ...node,
            };
        });
    }

    // Selected Default PIC Number
    if (typeof data.PICNumber != 'undefined' && data.PICNumber) {
        finalData.defaultPICNumberID = data.PICNumber.ID;
    }

    // Credit Cards
    if (typeof data.SavedCreditCards != 'undefined' && data.SavedCreditCards) {
        finalData.availableCreditCards = data.SavedCreditCards.edges.map(
            (item) => {
                const { node } = item;
                return {
                    ...node,
                    ExpiryMonthYear: node.Month + ' / ' + node.Year,
                };
            }
        );
    }

    // Selected Default Credit Card
    if (typeof data.SavedCreditCard != 'undefined' && data.SavedCreditCard) {
        finalData.defaultCreditCardID = Number(data.SavedCreditCard.ID);
    }

    // Postmen
    if (typeof data.Postmen != 'undefined' && data.Postmen) {
        finalData.availablePostmen = data.Postmen.edges.map((item) => {
            const { node } = item;
            return {
                ...node,
                ID: Number(node.ID),
            };
        });
    }

    // CartRule
    if (data?.CartRule) {
        finalData.availableCartRules = data.CartRule.edges.map((item) => {
            const { node } = item;
            return {
                ...node,
                ID: Number(node.ID),
            };
        });
    }

    // Referral Coupons
    if (typeof data.ReferralCoupons != 'undefined' && data.ReferralCoupons) {
        finalData.availableReferralCoupons = data.ReferralCoupons.edges.map(
            (item) => {
                const { node } = item;
                return {
                    ...node,
                    ID: Number(node.ID),
                };
            }
        );
    }

    // Addresseses
    if (typeof data.DeliveryAddresses != 'undefined' && data.DeliveryAddresses) {
        finalData.availableAddresses = data.DeliveryAddresses.edges.map((item) => {
            const { node } = item;
            return {
                ...node,
                ID: Number(node.ID),
            };
        });
    }

    // Dispatch Locations
    if (typeof data.DispatchLocations != 'undefined' && data.DispatchLocations) {
        finalData.availableDispatchLocations = data.DispatchLocations.edges.map((item) => {
            const { node } = item;
            return {
                ...node
            };
        });
    }


    // Default Dispatch Locations
    if (typeof data.DispatchLocations != 'undefined' && data.DispatchLocations) {
        finalData.defaultDisaptchLocationID = (data.DispatchLocations.edges.find(location => location.node.IsDefault)?.node?.ID) || data.DispatchLocations.edges[0]?.node.ID || 0;
    }



    // Selected Default Delivery Address
    if (typeof data.DeliveryAddress != 'undefined' && data.DeliveryAddress) {
        finalData.defaultDeliveryAddressID = Number(data.DeliveryAddress.ID);
    }

    // Selected Default Billing Address
    if (typeof data.BillingAddress != 'undefined' && data.BillingAddress) {
        finalData.defaultBillingAddressID = Number(data.BillingAddress.ID);
    }

    // Business Address
    if (typeof data.BusinessAddress != 'undefined' && data.BusinessAddress) {
        finalData.businessAddress = data.BusinessAddress;
    }

    // Parent
    if (typeof data.ParentID != 'undefined') {
        finalData.selectedParentID = Number(data.ParentID);

        finalData.availableWholesalerReseller.forEach((item) => {
            if (item.SupplierID == finalData.selectedParentID) {
                finalData.selectedAccountReference = item.AccountReference;
            }
        });
    }

    return finalData;
};
export const convertFilteredSuppliersToAReadableFormat = (list) => {
    return list;
};
export const convertStoreListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    let list = {};

    data.edges.map((item) => {
        const { node } = item;
        list[node.ID] = {
            ...node,
        };
    });

    return list;
};
export const convertStoreRegionsToAReadableFormat = (data) => {
    if (typeof data.States.edges == 'undefined') {
        return [];
    }

    let list = data.States.edges.map((item) => {
        const { node } = item;

        return node;
    });

    return list;
};

export const getDisplayedData = (displayList, fullList) => {
    let list = [];

    displayList.map((identifier) => {
        if (typeof fullList[identifier] != 'undefined') {
            list.push(fullList[identifier]);
        }
    });

    return list;
};
export const calculateTotalPages = (listingParams) => {
    const { totalRecords, perPage } = listingParams;
    const totalPages = Math.ceil(totalRecords / perPage);

    return totalPages;
};
export const calculatePaginationPages = (listingParams) => {
    let pages = [];

    const MAX_PAGES = 7;

    const { activePage } = listingParams;
    const totalPages = calculateTotalPages(listingParams);
    const midPoint = Math.floor(MAX_PAGES / 2);

    let minPageNum = activePage - midPoint;
    let maxPageNum = activePage + midPoint;

    while (minPageNum < 1) {
        minPageNum++;
        maxPageNum++;
    }
    while (maxPageNum > totalPages) {
        minPageNum--;
        maxPageNum--;
    }

    minPageNum = Math.max(1, minPageNum);
    maxPageNum = Math.min(totalPages, maxPageNum);

    // Populate data
    for (let i = minPageNum; i <= maxPageNum; i++) {
        if (i <= totalPages) {
            pages.push(i);
        }
    }

    pages.sort((a, b) => a - b);

    if (pages[pages.length - 1] != totalPages && totalPages >= 1) {
        pages[pages.length - 1] = totalPages;
    }
    if (pages[0] != 1) {
        pages[0] = 1;
    }

    return pages;
};
export const combineNames = (list) => {
    let names = [];
    if (list.length > 0) {
        list.map((item) => {
            if (item != null && item != '') {
                names.push(item);
            }
        });

        return names.join(' ');
    }

    return '';
};
export const escapeGraphQLInput = (value) => {
    return value.replace('"', '\\"');
};
export const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};
export const convertCouponProductsListingToAReadableFormat = (data) => {
    if (typeof data.edges == 'undefined') {
        return {};
    }

    const list = [];

    data.edges.map((item) => {

        const { node } = item;

        const element = {
            ID: node?.ID,
            Title: node?.Title,
            InternalItemID: node?.InternalItemID,
        }

        list.push(element);

    });

    return list;
};
